import React, { useEffect } from "react";
import "./AppDevelopment.css";
import appImg from "../../assets/images/AppD.png";

const AppDevelopment = () => {
  useEffect(() => {
    const sections = document.querySelectorAll(".reveal-app");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("show-app");
          }
        });
      },
      { threshold: 0.2 }
    );

    sections.forEach((sec) => observer.observe(sec));
  }, []);

  return (
    <>
      {/* ================= HERO SECTION ================= */}
      <section className="app-hero-section reveal-app">
        <div className="app-hero-container">
          {/* LEFT TEXT */}
          <div className="app-hero-text reveal-app">
            <h1>App Development Services</h1>

            <p>
              At NMD INFO-TECH SERVICES, we’re excited to expand our portfolio
              with Custom App Development solutions tailored to meet the dynamic
              needs of modern businesses.
            </p>

            <p>
              As mobile technology becomes a driving force in digital
              transformation, our team is here to help you build intuitive,
              high-performance apps that engage users and drive growth.
              <br />
              <strong>Innovative. Reliable. Future-ready.</strong>
            </p>

            <p>Let’s create the next big thing — together.</p>

            <button className="app-hero-btn">Get Started</button>
          </div>

          {/* RIGHT IMAGE */}
          <div className="app-hero-image reveal-app">
            <img src={appImg} alt="App Development" />
          </div>
        </div>
      </section>

      {/* ================= SECOND FORM SECTION ============================================== */}
      <section className="app-second-section reveal-app">
  <div className="app-second-container">
    {/* LEFT FORM BOX */}
    <div className="app-form-box reveal-app">
      <h2>Get an Appointment</h2>

      <form
        action="https://api.web3forms.com/submit"
        method="POST"
      >
        {/* REQUIRED: WEB3FORMS ACCESS KEY */}
        <input
          type="hidden"
          name="access_key"
          value="157f5dfc-898c-4749-aab8-a80e612db795"
        />

        <input type="text" name="name" placeholder="Name *" required />
        <input type="email" name="email" placeholder="Email *" required />
        <textarea name="message" placeholder="Message Here" rows="5"></textarea>

        <button type="submit" className="app-send-btn">Send</button>
      </form>
    </div>

    {/* RIGHT TEXT CONTENT */}
    <div className="app-second-text reveal-app">
      <h1>
        Why App Development? Because <br />
        Your Business Deserves a Spot in Their Pocket.
      </h1>

      <p>
        We live in a swipe, tap, and scroll world. Your customers are on
        their phones — and that’s exactly where your business needs to be.
      </p>

      <p>
        Mobile apps aren’t just nice-to-haves anymore — they’re{" "}
        <strong>powerful tools that create direct, personal connections</strong>{" "}
        with your audience.
      </p>

      <p>
        From boosting engagement to simplifying how things get done, the
        right app can turn everyday users into loyal customers.
      </p>

      <p>
        As smartphones become our go-to for everything, businesses that
        embrace app development aren’t just keeping up — they’re{" "}
        <strong>leading the way.</strong>
      </p>

      <p>
        <strong>
          Ready to turn your idea into an experience they can’t live
          without?
        </strong>{" "}
        Let’s build it.
      </p>
    </div>
  </div>
</section>

      
         {/* third section */}
     
      <section className="app-features-section reveal-app">
  <h2 className="app-feature-title">More Solutions We Offer</h2>
  
  <div className="scroll-line"></div>


  <div className="app-features-container">

   {/* CARD 1 */}
<div className="app-feature-card">
  <div className="card-inner">
    <div className="card-front">
      <div className="icon-box">📡</div>
      <h3>Custom App Development</h3>
      <p>Tailored to meet the specific needs of our clients, we develop native and cross-platform applications for iOS and Android platforms.</p>
    </div>

    <div className="card-back">
      <h3>Custom App Development</h3>
      <p>Tailored to meet the specific needs of our clients, we develop native and cross-platform applications for iOS and Android platforms.</p>
    </div>
  </div>
</div>


{/* CARD 2 */}
<div className="app-feature-card">
  <div className="card-inner">
    <div className="card-front">
      <div className="icon-box">🛠️</div>
      <h3>UI/UX Design</h3>
      <p>Our team of experienced designers ensures a visually appealing and user-friendly interface, enhancing the overall user experience.</p>
    </div>

    <div className="card-back">
      <h3>UI/UX Design</h3>
      <p>Our team of experienced designers ensures a visually appealing and user-friendly interface, enhancing the overall user experience.</p>
    </div>
  </div>
</div>


{/* CARD 3 */}
<div className="app-feature-card">
  <div className="card-inner">
    <div className="card-front">
      <div className="icon-box">⚡</div>
      <h3>Backend Development</h3>
      <p>We build robust and scalable backend systems, ensuring seamless integration of features and optimal performance.</p>
    </div>

    <div className="card-back">
      <h3>Backend Development</h3>
      <p>We build robust and scalable backend systems, ensuring seamless integration of features and optimal performance.</p>
    </div>
  </div>
</div>


{/* CARD 4 */}
<div className="app-feature-card">
  <div className="card-inner">
    <div className="card-front">
      <div className="icon-box">🔐</div>
      <h3>Quality Assurance</h3>
      <p>Rigorous testing procedures ensure flawless performance and excellent user experience.</p>
    </div>

    <div className="card-back">
      <h3>Quality Assurance</h3>
      <p>Rigorous testing procedures ensure flawless performance and excellent user experience.</p>
    </div>
  </div>
</div>


{/* CARD 5 */}
<div className="app-feature-card">
  <div className="card-inner">
    <div className="card-front">
      <div className="icon-box">☁️</div>
      <h3>Maintenance & Support</h3>
      <p>We offer ongoing support and maintenance to keep applications updated, secure, and aligned with evolving standards.</p>
    </div>

    <div className="card-back">
      <h3>Maintenance & Support</h3>
      <p>We offer ongoing support and maintenance to keep applications updated, secure, and aligned with evolving standards.</p>
    </div>
  </div>
</div>

  </div>
</section>

    </>
  );
};

export default AppDevelopment;
